import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'

import { Body, HeadlineM, Overline } from 'components/Text'
import Colors from 'styles/Colors'
import media from 'styles/media'

import { FluidImage } from 'Types'

type Props = {
  data: {
    rapidSense: FluidImage
  }
}

const RapidSense: React.FC<Props> = ({ data }) => {
  return (
    <Wrapper id="rapid-sense">
      <TextWrapper>
        <Label bullet>Empower collaboration</Label>
        <Title>RapidSense</Title>
        <Paragraph>
          RapidSense brings turn-key spatial perception to the Realtime
          Controller and RapidPlan. Empower robots to work in dynamic,
          unstructured environments. Workcell monitoring and active obstacle
          detection reliably identify obstacle-free spaces for robot motion.
        </Paragraph>
      </TextWrapper>
      <Lines>////////</Lines>
      <RobotImage>
        <Img fluid={data.rapidSense.childImageSharp.fluid} />
      </RobotImage>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  position: relative;
  display: flex;
  justify-content: flex-end;
  height: 48.8vw;
  min-height: 715px;
  ${media.tablet} {
    height: 128.5vw;
    min-height: 1135px;
  }
  ${media.mobile} {
    height: 199.2vw;
    min-height: 840px;
  }
`
const TextWrapper = styled.div`
  width: 64.3vw;
  padding: 11vw 0 0 22.7vw;
  background: ${Colors.softBlack};
  ${media.tablet} {
    width: 100%;
    padding: 81.5vw 0 0 48px;
  }
  ${media.mobile} {
    padding: 102.1vw 0 0 12px;
  }
`
const Label = styled(Overline)`
  color: white;
  margin-bottom: 1vw;
  ::after {
    color: ${Colors.blueYonder};
  ${media.fullWidth} {
    font-size: 0.8vw;
  }
`
const Title = styled(HeadlineM)`
  color: white;
  font-size: 3.2vw;
  margin-bottom: 1vw;
  ${media.tabletLandscape} {
    font-size: 54px;
  }
  ${media.mobile} {
    font-size: 36px;
    margin-top: 15px;
  }
`
const Paragraph = styled(Body)`
  color: white;
  width: 22.9vw;
  span {
    color: red;
  }
  ${media.fullWidth} {
    font-size: 0.9vw;
  }
  ${media.tabletLandscape} {
    width: 360px;
  }
  ${media.tablet} {
    width: 411px;
  }
  ${media.mobile} {
    max-width: calc(100% - 24px);
    margin-top: 21px;
  }
`
const RobotImage = styled.div`
  position: absolute;
  width: 43.6vw;
  top: 9.6vw;
  left: 96px;
  ${media.tablet} {
    width: calc(100% - 96px);
    left: 48px;
    top: 9.4vw;
  }
  ${media.mobile} {
    width: calc(100% - 24px);
    left: 12px;
    top: 25.6vw;
  }
`
const Lines = styled(HeadlineM)`
  color: ${Colors.blueYonder};
  position: absolute;
  right: 101px;
  top: 6.2vw;
  transform: rotate(-90deg);
  ${media.tabletLandscape} {
    font-size: 36px;
  }
  ${media.tablet} {
    top: 88.7vw;
    left: auto;
    right: 14px;
  }
  ${media.mobile} {
    display: none;
  }
`

export default RapidSense
